import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useImperativeHandle, forwardRef, useState, useCallback } from 'react';
import moment from 'moment';
import ReactDayPicker from 'react-day-picker';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
import { CalendarStyling } from './CalendarStyling';
import { CalendarHeader } from './CalendarHeader';
import { Day } from './Day';

var getStartOf = function getStartOf(part) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment();
  return moment(date).startOf(part).toDate();
};

var defaultDayRenderer = function defaultDayRenderer(day) {
  return React.createElement(Day, {
    day: day
  });
};
/**
 * A calendar component
 *
 * @visibleName Calendar
 *
 * @example ./__docs__/Calendar.md
 */


export var Calendar = forwardRef(function (_ref, ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      disabledDays = _ref.disabledDays,
      onDayChange = _ref.onDayChange,
      _ref$renderDay = _ref.renderDay,
      renderDay = _ref$renderDay === void 0 ? defaultDayRenderer : _ref$renderDay;
  var today = getStartOf('day');
  var minMonth = getStartOf('month', startDate);
  var maxMonth = getStartOf('month', endDate);
  var dayPickerRef = useRef(null);

  var _useState = useState(today),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDay = _useState2[0],
      selectDay = _useState2[1];

  useImperativeHandle(ref, function () {
    return {
      selectToday: function selectToday() {
        selectDay(today);
        if (dayPickerRef.current) dayPickerRef.current.showMonth(today);
      }
    };
  });
  var changeDate = useCallback(function (day, modifiers) {
    if (modifiers === null || modifiers === void 0 ? void 0 : modifiers.disabled) {
      return;
    }

    selectDay(day);
    onDayChange && onDayChange(day);
  }, [onDayChange]);

  var renderHeader = function renderHeader(props) {
    return React.createElement(CalendarHeader, Object.assign({}, props, {
      minMonth: minMonth,
      maxMonth: maxMonth
    }));
  };

  return React.createElement(CalendarStyling, null, React.createElement(ReactDayPicker, {
    fromMonth: minMonth,
    toMonth: maxMonth,
    canChangeMonth: true,
    navbarElement: renderHeader,
    captionElement: React.createElement(VisuallyHiddenElement, null),
    renderDay: renderDay,
    selectedDays: selectedDay,
    onDayClick: changeDate,
    ref: dayPickerRef,
    disabledDays: disabledDays
  }));
});